/**
 * reservedInstance模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例


const reservedInstance = {
  // 查询EC2 RI列表
  getReservedInstances(params) {
    return $http.post(`${global.API_URL}/sme/reservedInstance/getReservedInstances`, params);
  },
  // 验证标准化因子
  verifyReservedInstanceNormalizationFactor(params) {
    return $http.post(`${global.API_URL}/sme/reservedInstance/verifyReservedInstanceNormalizationFactor`, params);
  },
  // 查询RDS RI列表
  getReservedDBInstances(params) {
    return $http.post(`${global.API_URL}/sme/reservedInstance/getReservedDBInstances`, params);
  },
  // 查询Redshift RI列表
  getReservedNodes(params) {
    return $http.post(`${global.API_URL}/sme/reservedInstance/getReservedNodes`, params);
  },
  // 查询ElastiCache RI列表
  getReservedCacheNodes(params) {
    return $http.post(`${global.API_URL}/sme/reservedInstance/getReservedCacheNodes`, params);
  },
  // 查询Elasticsearch RI列表
  getReservedElasticsearchInstances(params) {
    return $http.post(`${global.API_URL}/sme/reservedInstance/getReservedElasticsearchInstances`, params);
  },
  // 导出EC2 RI列表
  exportReservedInstances(params) {
    return $http.post(`${global.API_URL}/sme/reservedInstance/exportReservedInstances`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  // 导出RDS RI列表
  exportReservedDBInstance(params) {
    return $http.post(`${global.API_URL}/sme/reservedInstance/exportReservedDBInstance`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  // 导出Redshift RI列表
  exportReservedNodes(params) {
    return $http.post(`${global.API_URL}/sme/reservedInstance/exportReservedNodes`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  // 导出ElastiCache RI列表
  exportReservedCacheNodes(params) {
    return $http.post(`${global.API_URL}/sme/reservedInstance/exportReservedCacheNodes`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  // 导出Elasticsearch RI列表
  exportReservedElasticsearchInstances(params) {
    return $http.post(`${global.API_URL}/sme/reservedInstance/exportReservedElasticsearchInstances`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  // 动态计算价格
  calculateReservedInstancePrice(params) {
    return $http.post(`${global.API_URL}/sme/reservedInstance/calculateReservedInstancePrice`, params);
  }
}

export default reservedInstance;



// WEBPACK FOOTER //
// ./src/api/reservedInstance.js